<script>
  import Router from "svelte-spa-router";
  import { push } from "svelte-spa-router";
  import Home from "./routes/Mail.svelte";
  import Sent from "./routes/Sent.svelte";
  import Apply from "./routes/Apply.svelte";
  import Confirm from "./routes/Confirm.svelte";
  import Complete from "./routes/Complete.svelte";
  import Terms from "./routes/Terms.svelte";
  import Sctln from "./routes/SCTLN.svelte";
  import Privacy from "./routes/Privacy.svelte";
  import Faq from "./routes/FAQ.svelte";
  import Help from "./routes/Help.svelte";
  import Msg from "./routes/Message.svelte";
  import { header } from "./stores.js";

  export const routes = {
    "/": Home,
    "/sending": Sent,
    "/entry": Apply,
    "/confirm": Confirm,
    "/complete": Complete,
    "/terms": Terms,
    "/sctln": Sctln,
    "/privacy": Privacy,
    "/faq": Faq,
    "/help": Help,
    "/message/:num?": Msg,
    "/error/:num?": Msg
  };
</script>

<header>
  <div class="bb-2">
    <div class="container">
      <h1 on:click={() => push('/')}>{$header}</h1>
    </div>
  </div>
</header>
<main>
  <div class="container">
    <Router {routes} />
  </div>
</main>
<footer>
  <div class="bt-2">
    <div class="container">
      <ul class="list-inline row flex jc-sb">
        <li class="col two ta-center mb-1"><a href="#/terms">利用規約</a></li>
        <li class="col auto ta-center mb-1">
          <a href="#/sctln">特定商取引法に基づく表示</a>
        </li>
        <li class="col auto ta-center mb-1">
          <a href="#/privacy">個人情報の取扱いについて</a>
        </li>
        <li class="col auto ta-center mb-1">
          <a href="#/faq">FAQ/お問い合わせ</a>
        </li>
      </ul>
      <div class="ta-center">© 2020 EVENTIFY</div>
    </div>
  </div>
</footer>
